import styled from 'styled-components';

export const StyledRoomFeedbackContainer = styled.div<{ $isSplitScreenOpen: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  gap: 2rem;
  padding: ${({ $isSplitScreenOpen }) => ($isSplitScreenOpen ? '3.2rem' : '3.2rem 20rem')};
  margin-bottom: 3rem;
  border-radius: 0.5rem;
  color: rgba(249, 249, 251, 1);
  background: linear-gradient(179.2deg, #223654 72.84%, #182337 145.61%, #151c2b 188.82%);

  form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1.2rem;
    max-width: 65rem;
  }

  > div {
    &[data-type='room-nps-form-thank-you'] {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.2rem;

      h2 {
        font-size: 1.6rem;
        color: rgba(249, 249, 251, 1);
      }

      p {
        font-size: 1.8rem;
        color: rgba(238, 239, 242, 1);
        text-align: center;
      }

      button {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        padding: 0.8rem 1.6rem;
        font-size: 1.8rem;
        color: rgba(21, 28, 43, 1);
        max-width: 13.6rem;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 3.2rem;

    form {
      max-width: 85%;
    }
  }
`;

export const StyledTitle = styled.h2`
  color: #fff;
  text-align: center;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin: 0;
`;

export const StyledScoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.2rem;
  max-width: 65rem;
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const StyledRadioItem = styled.label<{ $isSelected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5.6rem;
  width: 5.6rem;
  border-radius: 50%;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  background-color: ${({ $isSelected }) => ($isSelected ? 'rgb(25, 51, 108)' : 'rgba(28, 37, 56, 1)')};
  border: 0.1rem solid ${({ $isSelected }) => ($isSelected ? 'rgb(113, 156, 249)' : 'rgba(62, 71, 90, 1)')};
  cursor: pointer;
`;

export const StyledHiddenRadio = styled.input.attrs({ type: 'radio' })`
  display: none;
`;

export const StyledCommentArea = styled.textarea<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  min-height: 12.4rem;
  padding: 1rem;
  background-color: #1a1f2e;
  border: 0.1rem solid #2a324d;
  border-radius: 0.8rem;
  color: white;
  resize: none;
  font-family: inherit;
  ::placeholder {
    color: rgba(184, 190, 201, 1);
  }

  &:focus {
    outline: none;
    border-color: #3a4366;
  }
`;

export const StyledSubmitButton = styled.button`
  background-color: rgba(163, 234, 42, 1);
  color: #1a1f2e;
  border: 0.1rem solid rgba(163, 234, 42, 1);
  border-radius: 0.8rem;
  width: 25.6rem;
  height: 4.2rem;
  padding: 1rem 1.6rem;
  cursor: pointer;
  transition: opacity 0.2s;
  align-self: center;
  font-size: ${({ theme }) => theme.fonts.sizes.medium};

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StyledScoreScale = styled.div<{ $isSplitScreenOpen: boolean }>`
  display: ${({ $isSplitScreenOpen }) => ($isSplitScreenOpen ? 'none' : 'flex')};
  justify-content: space-between;
  color: rgba(249, 249, 251, 1);
  max-width: 65rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;

export const StyledScoreLabel = styled.span<{ $isSelected?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: rgba(249, 249, 251, 1);

  background-color: ${({ $isSelected }) => ($isSelected ? 'rgba(45, 61, 95, 1)' : 'none')};
  padding: 0.7rem 1.2rem;
  border-radius: 10rem;
`;
